<script lang="ts">
  import type { LanguageCode } from '$gql/storefront/schemas';
  import { optimalUSCountry, parseCountryAsCode } from '$lib/country';
  import { lang } from '$lib/lang';
  import { shopify } from '$lib/shopify';
  import { createQuery } from '@tanstack/svelte-query';

  export let handle: string;
  export let enabled = true;

  /* GraphQL */ `
    query getQuickAddToCartProduct($handle: String!, $country: CountryCode, $lang: LanguageCode)
    @inContext(language: $lang, country: $country) {
      product(handle: $handle) {
        ...ProductCard
        ...QuickAddToCart
      }
    }
  `;

  $: client = createQuery({
    enabled: enabled,
    staleTime: 5 * 60 * 1000,
    queryKey: ['getQuickAddToCartProduct', handle, $lang],
    queryFn: async () => {
      return await $shopify.getQuickAddToCartProduct({
        handle,
        lang: $lang.toUpperCase() as LanguageCode,
        country: parseCountryAsCode($optimalUSCountry)
      });
    }
  });

  const load = () => {
    enabled = true;
  };
</script>

<slot loading={$client.isLoading} error={$client.isError} product={$client.data?.product} {load} />
